import React from "react";
import { TableRow, TableCell, Checkbox } from "@mui/material";
import UserAccessSubRow from "../UserAccessSubRow";
import EzControlledCheckBoxWithLabel from "../../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import "../index.css";

const UserAccessRow = ({ module, control, errors, handleChange }) => {
  return (
    <>
      <TableRow className="module-row">
        <TableCell className="table-cell module-name-cell">
          {module.title}
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={module.title}
            value={module.view}
            control={control}
            isError={errors[module.title]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "view", e.target.checked)
            }
          />
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={module.title}
            value={module.createCrud}
            control={control}
            isError={errors[module.title]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "createCrud", e.target.checked)
            }
          />
        </TableCell>
        <TableCell className="table-cell permission-cell">
          <EzControlledCheckBoxWithLabel
            name={module.title}
            value={module.editCrud}
            control={control}
            isError={errors[module.title]}
            labelClassName={"mr-2"}
            onChange={(e) =>
              handleChange(module.menuId, "editCrud", e.target.checked)
            }
          />
        </TableCell>
      </TableRow>
      {module?.accessDTOList?.map((child) => (
        <React.Fragment key={child.menuId}>
          <TableRow
            sx={
              child?.accessDTOList?.length > 0
                ? { backgroundColor: "#fff2d6" }
                : {}
            }
          >
            <TableCell className="table-cell module-name-cell">
              {child.title}
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={child.title}
                value={child.view}
                control={control}
                isError={errors[child.title]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "view", e.target.checked)
                }
              />
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={child.title}
                value={child.createCrud}
                control={control}
                isError={errors[child.title]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "createCrud", e.target.checked)
                }
              />
            </TableCell>
            <TableCell className="table-cell permission-cell">
              <EzControlledCheckBoxWithLabel
                name={child.title}
                value={child.editCrud}
                control={control}
                isError={errors[child.title]}
                labelClassName={"mr-2"}
                onChange={(e) =>
                  handleChange(child.menuId, "editCrud", e.target.checked)
                }
              />
            </TableCell>
          </TableRow>

          {child?.accessDTOList?.map((sub) => (
            <UserAccessSubRow
              key={sub.menuId}
              sub={sub}
              handleChange={handleChange}
              control={control}
              errors={errors}
            />
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default UserAccessRow;
